import React, { useState } from 'react';
import Text from '../../../Text';
import Toggle from '../../../Transition/Toggle';
import AccordionItemCaret from '../AccordionItemCaret';
import { timingMap } from '../../../Transition/constants';
import { dataHooks } from '../../constants';
import { WixStyleReactContext } from '../../../WixStyleReactProvider/context';
import { st, classes } from './AccordionItem.st.css.js';
function AccordionItem({ icon, title, subtitle, open, children, onToggle, onMouseLeave, onMouseEnter, disabled, skin, hideShadow, className, size, horizontalPadding, last, transitionSpeed = 'medium', onAnimationEnter, onAnimationExit, buttonType = 'textButton', expandLabel, collapseLabel, showLabel, }) {
    const [hover, setHover] = useState(false);
    const caretProps = {
        hover,
        buttonType,
        expandLabel,
        collapseLabel,
        showLabel,
        open,
        disabled,
        skin,
    };
    const _onMouseLeave = (e) => {
        setHover(false);
        !disabled && onMouseLeave && onMouseLeave(e);
    };
    const _onMouseEnter = (e) => {
        setHover(true);
        !disabled && onMouseEnter && onMouseEnter(e);
    };
    return (React.createElement(WixStyleReactContext.Consumer, null, ({ newColorsBranding }) => (React.createElement("div", { className: st(classes.root, {
            disabled,
            hover,
            open,
            skin,
            hideShadow,
            size,
            horizontalPadding,
            last,
            newColorsBranding,
        }, className) },
        React.createElement("div", { "data-hook": dataHooks.item },
            React.createElement("div", { onClick: !disabled ? onToggle : () => { }, className: st(classes.header, { size }), "data-hook": "header", onMouseEnter: _onMouseEnter, onMouseLeave: _onMouseLeave },
                icon && (React.createElement("div", { className: classes.icon, "data-hook": "icon" }, icon)),
                React.createElement("div", { className: classes.titleWrapper },
                    title && (React.createElement("div", { "data-hook": "titleContainer" }, typeof title === 'string' ? (React.createElement(Text, { dataHook: "title", ellipsis: true, weight: "normal" }, title)) : (title))),
                    subtitle && (React.createElement("div", { "data-hook": dataHooks.subtitle }, typeof subtitle === 'string' ? (React.createElement(Text, { size: "small" }, subtitle)) : (subtitle)))),
                React.createElement(AccordionItemCaret, Object.assign({}, caretProps))),
            React.createElement(Toggle, { show: open, timeout: timingMap[transitionSpeed], onStart: onAnimationEnter, onEnd: onAnimationExit, unmountOnExit: true },
                React.createElement("div", { "data-hook": "children", className: classes.children }, children)))))));
}
export default AccordionItem;
//# sourceMappingURL=AccordionItem.js.map